import { BRAND_LIST, CountryLanguageSwitcher, Languages } from 'typings'
import * as Typings from '../typings'

const SpainLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'es',

  LONG_NAME: 'Spain',
  SHORT_NAME: 'ES',
  DISPLAY_COUNTRY: 'España',
  SHOW_TIME_IN_MILITARY: true,
  LANGUAGES: {
    ES: 'es',
    EN: 'en',
  },

  [BRAND_LIST.UQ]: {
    [Languages.ES]: {
      LANGUAGE_CODE: 'es',
      DISPLAY_NAME: 'España (Español)',
      CONTACT_US_URL: 'https://faq-es.uniqlo.com/',
      HOME_PAGE_URL: 'https://www.uniqlo.com/es/es',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/es/es/',
      TERMS_OF_USE_URL:
        'https://faq-es.uniqlo.com/pkb_Home_UQ_ES?l=es&c=category_uq_eu_dk_se%3ARenew_UQES_C7_3',
      PRIVACY_POLICY_URL:
        'https://faq-es.uniqlo.com/pkb_Home_UQ_ES?l=es&c=category_uq_eu_dk_se%3ARenew_UQES_C7_2',
      AREAS: {
        '1': 'Álava',
        '2': 'Albacete',
        '3': 'Alicante',
        '4': 'Almería',
        '5': 'Asturias',
        '6': 'Ávila',
        '7': 'Badajoz',
        '8': 'Balearic Islands',
        '9': 'Barcelona',
        '10': 'Burgos',
        '11': 'Cáceres',
        '12': 'Cádiz',
        '13': 'Cantabria',
        '14': 'Castellón',
        '15': 'Ceuta',
        '16': 'Ciudad Real',
        '17': 'Córdoba',
        '18': 'Cuenca',
        '19': 'Gerona',
        '20': 'Granada',
        '21': 'Guadalajara',
        '22': 'Guipúzcoa',
        '23': 'Huelva',
        '24': 'Huesca',
        '25': 'Jaén',
        '26': 'La Coruña',
        '27': 'La Rioja',
        '28': 'Las Palmas',
        '29': 'León',
        '30': 'Lérida',
        '31': 'Lugo',
        '32': 'Madrid',
        '33': 'Málaga',
        '34': 'Melilla',
        '35': 'Murcia',
        '36': 'Navarra',
        '37': 'Orense',
        '38': 'Palencia',
        '39': 'Pontevedra',
        '40': 'Salamanca',
        '41': 'Santa Cruz de Tenerife',
        '42': 'Segovia',
        '43': 'Sevilla',
        '44': 'Soria',
        '45': 'Tarragona',
        '46': 'Teruel',
        '47': 'Toledo',
        '48': 'Valencia',
        '49': 'Valladolid',
        '50': 'Vizcaya',
        '51': 'Zamora',
        '52': 'Zaragoza',
      },
    },
    [Languages.EN]: {
      LANGUAGE_CODE: 'en',
      DISPLAY_NAME: 'Spain (English)',
      HOME_PAGE_URL: 'https://www.uniqlo.com/es/en',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/es/en/',
      CONTACT_US_URL: 'https://faq-es.uniqlo.com/pkb_Home_UQ_ES?l=en_US',
      TERMS_OF_USE_URL:
        'https://faq-es.uniqlo.com/pkb_Home_UQ_ES?l=en_US&c=category_uq_eu_dk_se%3ARenew_UQES_C7_3',
      PRIVACY_POLICY_URL:
        'https://faq-es.uniqlo.com/pkb_Home_UQ_ES?l=en_US&c=category_uq_eu_dk_se%3ARenew_UQES_C7_2',
      AREAS: {
        '1': 'Álava',
        '2': 'Albacete',
        '3': 'Alicante',
        '4': 'Almería',
        '5': 'Asturias',
        '6': 'Ávila',
        '7': 'Badajoz',
        '8': 'Balearic Islands',
        '9': 'Barcelona',
        '10': 'Burgos',
        '11': 'Cáceres',
        '12': 'Cádiz',
        '13': 'Cantabria',
        '14': 'Castellón',
        '15': 'Ceuta',
        '16': 'Ciudad Real',
        '17': 'Córdoba',
        '18': 'Cuenca',
        '19': 'Gerona',
        '20': 'Granada',
        '21': 'Guadalajara',
        '22': 'Guipúzcoa',
        '23': 'Huelva',
        '24': 'Huesca',
        '25': 'Jaén',
        '26': 'La Coruña',
        '27': 'La Rioja',
        '28': 'Las Palmas',
        '29': 'León',
        '30': 'Lérida',
        '31': 'Lugo',
        '32': 'Madrid',
        '33': 'Málaga',
        '34': 'Melilla',
        '35': 'Murcia',
        '36': 'Navarra',
        '37': 'Orense',
        '38': 'Palencia',
        '39': 'Pontevedra',
        '40': 'Salamanca',
        '41': 'Santa Cruz de Tenerife',
        '42': 'Segovia',
        '43': 'Sevilla',
        '44': 'Soria',
        '45': 'Tarragona',
        '46': 'Teruel',
        '47': 'Toledo',
        '48': 'Valencia',
        '49': 'Valladolid',
        '50': 'Vizcaya',
        '51': 'Zamora',
        '52': 'Zaragoza',
      },
    },
  },

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 39.919748,
    INITIAL_LONGITUDE: -4.3785635,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  MAP_URL: 'https://www.uniqlo.com/es/es/content/store-locator.html',

  POSTCODE_FORMAT: /^[0-9]{5}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default SpainLocale
